import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 4 9"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M.09 8.919A.395.395 0 0 1 0 8.678c0-.08.018-.16.072-.221L3.325 4.5.072.543A.371.371 0 0 1 .09.081a.28.28 0 0 1 .411.02L3.933 4.28c.09.12.09.321 0 .442L.501 8.899a.279.279 0 0 1-.411.02Z"
    }, null, -1)
  ])))
}
export default { render: render }